import EditTemplateModal from './components/EditTemplateModal';
import { QuestionnaireTemplateProps } from '@/types/questionnaire';
import AdminQuestionnaireLayout from '../components/AdminQuestionnaireLayout';
import { AdminSidebarItems } from '../components/AdminSidebarItems';
import useQuestionnaireTemplate from './hooks/useQuestionnaireTemplate';
import useEditModal from './hooks/useEditModal';
import { TemplateDetails } from './components/TemplateDetails';
import { TemplateBreadCrumb } from './components/TemplateBreadcrumb';

interface IndexProps {
  templates: QuestionnaireTemplateProps[];
}

export default function Index({ templates }: IndexProps) {
  const {
    currentTemplateData,
    isTemplateLoading: isLoading,
    currentTemplateId,
    setCurrentTemplateId,
  } = useQuestionnaireTemplate({ templates });

  const { isEditModalOpen, setIsEditModalOpen, updateTemplateMutation } =
    useEditModal({ templateId: currentTemplateId });

  if (!templates.length) return <div>No Templates available</div>;

  return (
    <>
      <AdminQuestionnaireLayout
        heading="Templates"
        breadCrumbComponent={<TemplateBreadCrumb />}
        leftComponent={
          <AdminSidebarItems
            data={templates}
            selectedId={currentTemplateId}
            onSelect={setCurrentTemplateId}
            testId="template-item"
            displayField="title"
          />
        }
        rightComponent={
          <TemplateDetails
            templateDetails={currentTemplateData}
            isLoading={isLoading}
            onEdit={() => setIsEditModalOpen(true)}
          />
        }
      />
      {currentTemplateData && (
        <EditTemplateModal
          key={currentTemplateData.id}
          templateId={currentTemplateData.id}
          initialTitle={currentTemplateData.title}
          initialDescription={currentTemplateData.description}
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          onSave={(templateId, updates) => {
            return updateTemplateMutation.mutateAsync({
              id: templateId,
              updates,
            });
          }}
        />
      )}
    </>
  );
}
